"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.gotoNextMonth = function () {
            _this.currentDate = getNextMonth(_this.currentDate);
            _this.initDate();
            _this.update();
        };
        _this.gotoPreMonth = function () {
            _this.currentDate = getPreMonth(_this.currentDate);
            _this.initDate();
            _this.update();
        };
        _this.gotoNextYear = function () {
            _this.currentDate = nextYear(_this.currentDate);
            _this.initDate();
            _this.update();
        };
        _this.gotoPreYear = function () {
            _this.currentDate = preYear(_this.currentDate);
            _this.initDate();
            _this.update();
        };
        _this.onSelectDate = function (evt) {
            _this.selectedDate = evt.target.getAttribute('data-date');
            _this.noSelected = false;
            _this.fire('select', _this.selectedDate);
            _this.update(true);
        };
        _this.toggle = function () {
            _this.initCurrentDate();
            _this.initDate();
            _this.fire('toggle', _this.selectedDate);
        };
        return _this;
    }
    DatePicker.prototype.install = function () {
        this.now = new Date();
        this.nowYear = this.now.getFullYear();
        this.nowMonth = this.now.getMonth();
        this.nowDay = this.now.getDate();
        this.selectedDate = this.props.selectedDate;
        this.initCurrentDate();
        this.initDate();
    };
    DatePicker.prototype.installed = function () {
        var _this = this;
        Promise.resolve().then(function () { return require('./locale/' + _this.props.lan + '.js'); }).then(function (locale) {
            console.log(locale.default);
            _this.locale = locale.default;
            _this.update(true);
        });
    };
    DatePicker.prototype.initCurrentDate = function () {
        if (this.selectedDate) {
            this.dateArr = this.selectedDate.split('-');
            this.currentDate = new Date(Number(this.dateArr[0]), Number(this.dateArr[1]) - 1, Number(this.dateArr[2]));
        }
        else {
            // this.selectedDate = this.nowYear + '-' + (this.nowMonth + 1) + '-' + this.nowDay
            // this.noSelected = true
            this.currentDate = this.now;
        }
    };
    DatePicker.prototype.initDate = function () {
        this.year = this.currentDate.getFullYear();
        this.month = this.currentDate.getMonth();
        this.day = this.currentDate.getDate();
        this.begin = getFirstDayWeek(this.year, this.month);
        this.count = getMonthDayCount(this.year, this.month);
        this.preMonthDate = getPreMonth(this.currentDate);
        this.preYear = this.preMonthDate.getFullYear();
        this.preMonth = this.preMonthDate.getMonth();
        this.preCount = getMonthDayCount(this.preYear, this.preMonth);
        this.nextMonthDate = getNextMonth(this.currentDate);
        this.nextYear = this.nextMonthDate.getFullYear();
        this.nextMonth = this.nextMonthDate.getMonth();
    };
    DatePicker.prototype.getDay = function (y, x) {
        var dateStr;
        if (y === 0) {
            if (x < this.begin) {
                dateStr = this.preYear + '-' + (this.preMonth + 1) + '-' + (this.preCount - this.begin + x + 1);
                return omi_1.h("td", { "data-date": dateStr, class: '_out-date' + (dateStr === this.selectedDate && !this.noSelected ? ' selected' : '') }, this.preCount - this.begin + x + 1);
            }
            else {
                var d = x - this.begin + 1;
                dateStr = this.year + '-' + (this.month + 1) + '-' + d;
                if (d === this.nowDay && this.year === this.nowYear && this.month === this.nowMonth) {
                    return omi_1.h("td", { "data-date": dateStr, class: '_now' + (dateStr === this.selectedDate && !this.noSelected ? ' selected' : '') }, d);
                }
                else {
                    var cls = dateStr === this.selectedDate && !this.noSelected ? { 'class': 'selected' } : null;
                    return omi_1.h("td", __assign({ "data-date": dateStr }, cls), d);
                }
            }
        }
        else {
            var temp = y * 7 + x - this.begin + 1;
            if (temp <= this.count) {
                dateStr = this.year + '-' + (this.month + 1) + '-' + temp;
                if (temp === this.nowDay && this.year === this.nowYear && this.month === this.nowMonth) {
                    return omi_1.h("td", { "data-date": dateStr, class: '_now' + (dateStr === this.selectedDate && !this.noSelected ? ' selected' : '') }, temp);
                }
                else {
                    var cls = dateStr === this.selectedDate && !this.noSelected ? { 'class': 'selected' } : null;
                    return omi_1.h("td", __assign({ "data-date": dateStr }, cls), temp);
                }
            }
            else {
                dateStr = this.nextYear + '-' + (this.nextMonth + 1) + '-' + (temp - this.count);
                return omi_1.h("td", { "data-date": dateStr, class: '_out-date' + (dateStr === this.selectedDate && !this.noSelected ? ' selected' : '') }, temp - this.count);
            }
        }
    };
    DatePicker.prototype.render = function (props) {
        var arr = [];
        for (var i = 0; i < 6; i++) {
            arr.push(omi_1.h("tr", null,
                this.getDay(i, 0),
                this.getDay(i, 1),
                this.getDay(i, 2),
                this.getDay(i, 3),
                this.getDay(i, 4),
                this.getDay(i, 5),
                this.getDay(i, 6)));
        }
        return (omi_1.h("div", { class: 'm-date-picker' },
            omi_1.h("div", { class: '_ctn' },
                omi_1.h("div", { class: "_header" },
                    omi_1.h("div", { style: "position: relative;" },
                        omi_1.h("a", { class: "prev-year-btn", role: "button", title: "\u4E0A\u4E00\u5E74", onClick: this.gotoPreYear }),
                        omi_1.h("a", { class: "prev-month-btn", role: "button", title: "\u4E0A\u4E2A\u6708", onClick: this.gotoPreMonth }),
                        omi_1.h("span", { class: "ym-select" },
                            omi_1.h("a", { class: "year-select", role: "button", title: "\u9009\u62E9\u5E74\u4EFD" },
                                this.year,
                                "\u5E74"),
                            omi_1.h("a", { class: "month-select", role: "button", title: "\u9009\u62E9\u6708\u4EFD" },
                                this.month + 1,
                                "\u6708")),
                        omi_1.h("a", { class: "next-month-btn", title: "\u4E0B\u4E2A\u6708", onClick: this.gotoNextMonth }),
                        omi_1.h("a", { class: "next-year-btn", title: "\u4E0B\u4E00\u5E74", onClick: this.gotoNextYear }))),
                omi_1.h("table", null,
                    omi_1.h("thead", null,
                        omi_1.h("tr", null,
                            omi_1.h("th", null, "\u65E5"),
                            omi_1.h("th", null, "\u4E00"),
                            omi_1.h("th", null, "\u4E8C"),
                            omi_1.h("th", null, "\u4E09"),
                            omi_1.h("th", null, "\u56DB"),
                            omi_1.h("th", null, "\u4E94"),
                            omi_1.h("th", null, "\u516D"))),
                    omi_1.h("tbody", { onClick: this.onSelectDate }, arr)))));
    };
    DatePicker.defaultProps = {
        lan: 'en'
    };
    DatePicker.propTypes = {
        lan: String,
        selectedDate: String
    };
    DatePicker.css = css;
    DatePicker = __decorate([
        omi_1.tag('m-date-picker')
    ], DatePicker);
    return DatePicker;
}(omi_1.WeElement));
//星期日是0
function getFirstDayWeek(e, t) {
    var n = new Date(e, t, 1);
    return n.getDay();
}
function getMonthDayCount(e, t) {
    var arr = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    arr[1] = isLeapYear(e) ? 29 : 28;
    return arr[t];
}
function isLeapYear(e) {
    return e % 400 == 0 || e % 100 != 0 && e % 4 == 0;
}
function getNextMonth(e) {
    var t = e.getMonth();
    return t === 11 ? new Date(e.getFullYear() + 1, 0) : new Date(e.getFullYear(), e.getMonth() + 1);
}
function getPreMonth(e) {
    var t = e.getMonth();
    return t === 0 ? new Date(e.getFullYear() - 1, 11) : new Date(e.getFullYear(), e.getMonth() - 1);
}
function nextYear(d) {
    return new Date(d.getFullYear() + 1, d.getMonth(), d.getDate());
}
function preYear(d) {
    return new Date(d.getFullYear() - 1, d.getMonth(), d.getDate());
}
